<template>
  <div class="relative h-auto w-full min-h-0 m-0 mb-4 md:m-4 bg-green-100 rounded-2xl overflow-hidden rounded-br-none">
    <img
      src="/images/firm-info-graphic.png"
      alt="Firm Info Graphic"
      class="absolute top-[50px] left-[50px] w-[calc(100%-50px)] h-[calc(100%-50px)] object-cover object-left-top"
    />
  </div>
</template>

<script>
export default {
  name: "FirmInfoGraphic",
}
</script>
